import Vue from 'vue';
import Router from 'vue-router';
import Reserve from '@/views/Reserve.vue';
import ThankYou from '@/views/ThankYou.vue';
import ReservationDetails from '@/views/ReservationDetails.vue';
import ManageReservations from '@/views/ManageReservations.vue';
import CheckIn from '@/views/CheckIn.vue';
import WidgetExamples from '@/views/WidgetExamples.vue';
import Queue from '@/views/Queue.vue';

Vue.use(Router);

const baseRoutes: any = [
  {
    path: '*',
    redirect: '/reserve',
  },
  {
    path: '/reserve',
    name: 'reserve',
    component: Reserve,
  },
  {
    path: '/queue',
    name: 'queue',
    component: Queue,
    props: true,
  },
  {
    path: '/thank-you',
    name: 'thank-you',
    component: ThankYou,
    props: true,
  },
  {
    path: '/reservation/:reservationQRCode',
    name: 'reservation-details',
    component: ReservationDetails,
    props: true,
  },
  {
    path: '/reservation/:reservationQRCode/modify',
    name: 'modify-reservation',
    component: Reserve,
    props: true,
  },
  {
    path: '/manage-reservations/:pathExternalUserId',
    name: 'manage-reservations',
    component: ManageReservations,
    props: true,
  },
  {
    path: '/reservation/:reservationQRCode/checkIn',
    name: 'location-check-in',
    component: CheckIn,
    props: true,
  },
  {
    path: '/widget-examples',
    name: 'widget-examples',
    component: WidgetExamples,
  },
];

const router = new Router({
  mode: 'history',
  routes: baseRoutes,
});

export default router;
